import { client, gql } from './Client';

const dataEntryClerksQuery = gql`
  query allClerkInfo {
    allClerkInfo {
      pkClerk
      fkUser
      fkServiceProvider
      isActive
      title
      companyName
      firstName
      lastName
      phone
      emailAddress
      primaryAddress
      comment
      dateModified
      modifiedBy
    }
  }
`;

const dataEntryClerks = async () => {
  const response = await client.query({ query: dataEntryClerksQuery });

  // Modify properties of the response
  const modifiedData = response.data.allClerkInfo.map((clerk: { pkClerk: number }) => ({
    ...clerk,
    clerkId: clerk.pkClerk,
  }));

  return modifiedData;
};

export { dataEntryClerks };
